import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { IInstituicaoFinanceira } from '../model/instituicao.model';

@Injectable()
export class InstituicaoFinanceiraService extends EntityService<
  IInstituicaoFinanceira
> {
  constructor(protected configService: ConfigService) {
    super({
      baseEntityEndPoint: 'instituicao_pagamento',
      urlBackend: configService.backendURL
    });
  }
}
